/**
 * Centralized endpoint paths for the TraceSync API. `apiClient`'s baseURL
 * already includes `/tracesync/` (from REACT_APP_API_BASE_URL), so paths
 * here are relative to that.
 *
 * Keeping every path in one file means a route change on the backend is a
 * one-line fix here instead of a hunt through service modules.
 */
export const BATCH_ENDPOINTS = {
  list: "batch/",
  create: "batch/",
  detail: (uid) => `batch/${uid}`,
  update: (uid) => `batch/${uid}`,
  delete: (uid) => `batch/${uid}`,
  dispatchHistory: "batch/dispatch-history",
  dispatchSlip: (uid) => `batch/${uid}/dispatch-slip`,
  dispatch: "batch/dispatch",
  qrDownload: "batch/qr/download",
};
